import React, { Component } from 'react'
import './Terms.css'

export default class Terms extends Component {
  render() {
    return (
      <div className="terms">
        <div className="terms-section-content">
          To get the latest features, make sure your devices are running the
          latest software version.
        </div>
        <div className="terms-section-content">
          Update to latest version by going to Settings. Software Update. Tap
          Download and Install.
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/terms/Terms.js